import React from "react";
import { Link } from "react-router-dom";

const formatTimestamp = (value) => {
  if (!value) return "just now";
  const date = value.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? "just now" : date.toLocaleString();
};

function AppCard({ app }) {
  const updatedLabel = formatTimestamp(app.updatedAt || app.createdAt);
  const summary = app.summary || app.description || app.idea || "No description provided.";
  const statusLabel = app.status || "Draft";

  return (
    <div className="card">
      <div className="flex-between">
        <h4 className="card__title">{app.name || "Untitled app"}</h4>
        <div className="badge">{statusLabel}</div>
      </div>
      <div className="card__meta">Updated {updatedLabel}</div>
      <p className="muted">{summary}</p>
      {app.tags?.length ? (
        <div className="chips" style={{ marginTop: "12px" }}>
          {app.tags.map((tag) => (
            <span key={tag} className="chip">
              {tag}
            </span>
          ))}
        </div>
      ) : null}
      <div className="flex-between" style={{ marginTop: "14px" }}>
        <Link to={`/apps/${app.id}`} className="button secondary">
          Edit app
        </Link>
        <div className="flex-center">
          <button className="button secondary">Share</button>
          <button className="button secondary">Export</button>
        </div>
      </div>
    </div>
  );
}

export default AppCard;
